import {
    Inject, forwardRef, Component, animate, transition, style, state, trigger, Input,
    ContentChild
} from "@angular/core";
import {Accordion} from "./accordion.component";
import {Header, Footer} from "../common/common";

let nextId: number = 0;


export class AccordionGroup {

     opened: boolean = false;
     disabled: boolean = false;
     name: string = "group-" + nextId++;
     header: string;
     type: string = "default";

     private headerTemplate: Header;
     private footerTemplate: Footer;

    constructor( private parent: Accordion) {
    }

    private toggle(): void {
        if (this.disabled) return;
        this.opened ? this.parent.close(this.name) : this.parent.open(this.name);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "a2-accordion-group",
    templateUrl: "src/bootstrap/accordion/accordion-group.component.html",
    animations: [
        trigger("state", [
            state("collapsed", style({
                display: "none",
                position: "relative",
                height: 0,
                overflow: "hidden"
            })),
            state("expanded", style({
                display: "block",
            })),
            transition("collapsed => expanded", animate("800ms ease-in-out")),
            transition("expanded => collapsed", animate("800ms ease-in-out"))
        ])
    ]
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
{type: Accordion, decorators: [{ type: Inject, args: [forwardRef(() => Accordion), ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'opened': [{ type: Input },],
'disabled': [{ type: Input },],
'name': [{ type: Input },],
'header': [{ type: Input },],
'type': [{ type: Input },],
'headerTemplate': [{ type: ContentChild, args: [Header, ] },],
'footerTemplate': [{ type: ContentChild, args: [Footer, ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
